import {
  RentalGrowthMarketTrendsSummaryWebApiHandler_summary,
  RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom,
  RentalGrowthTopRentalMarketsWebApiHandler_topMarkets,
} from '@zg-rentals/ts-rental-growth-api-client';
import type {
  GetMarketTrendsSummaryRequestDto,
  GetMarketTrendsSummaryResponseDto,
  GetMedianRentByBedroomRequestDto,
  GetMedianRentByBedroomResponseDto,
  GetTopRentalMarketsRequestDto,
  GetTopRentalMarketsResponseDto,
} from '@zg-rentals/ts-rental-growth-api-client';

export type {
  GetMarketTrendsSummaryRequestDto,
  GetMarketTrendsSummaryResponseDto,
  GetMedianRentByBedroomRequestDto,
  GetMedianRentByBedroomResponseDto,
  GetTopRentalMarketsRequestDto,
  GetTopRentalMarketsResponseDto,
};

export const getMarketTrendsSummary = (
  params: GetMarketTrendsSummaryRequestDto,
  client?: Parameters<typeof RentalGrowthMarketTrendsSummaryWebApiHandler_summary>[1],
): Promise<GetMarketTrendsSummaryResponseDto> => RentalGrowthMarketTrendsSummaryWebApiHandler_summary(params, client);

export const getTopRentalMarkets = (
  params: GetTopRentalMarketsRequestDto,
  client?: Parameters<typeof RentalGrowthTopRentalMarketsWebApiHandler_topMarkets>[1],
): Promise<GetTopRentalMarketsResponseDto> => RentalGrowthTopRentalMarketsWebApiHandler_topMarkets(params, client);

export const getMedianRentByBedroom = (
  params: GetMedianRentByBedroomRequestDto,
  client?: Parameters<typeof RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom>[1],
): Promise<GetMedianRentByBedroomResponseDto> =>
  RentalGrowthMedianRentByBedroomWebApiHandler_medianRentByBedroom(params, client);
